import ColorPicker from './src/main';


ColorPicker.install = function(Vue) {
  Vue.component(ColorPicker.name, ColorPicker);
};

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/color-picker/index.js